// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { NonSkuCaratWeightRangeFragmentDoc } from './nonSkuCaratWeightRange.fragment.generated';
import { NonSkuPriceRangeFragmentDoc } from './nonSkuPriceRange.fragment.generated';
import { StoneShapeFragmentDoc } from './stoneShape.fragment.generated';
import { StoneCrystalFragmentDoc } from './stoneCrystal.fragment.generated';
import { StoneColorFragmentDoc } from '../../gems/fragments/StoneColor.fragment.generated';
export const NonSkuGemstoneBoundsFragmentDoc = gql`
    fragment nonSkuGemstoneBounds on NonSkuGemstonesBounds {
  __typename
  caratWeight {
    ...nonSkuCaratWeightRange
  }
  price(currency: $currency, region: $region) {
    ...nonSkuPriceRange
  }
  shapes {
    ...stoneShape
  }
  types {
    id
    __typename
    crystal {
      ...stoneCrystal
    }
    color {
      ...stoneColor
    }
  }
}
    ${NonSkuCaratWeightRangeFragmentDoc}
${NonSkuPriceRangeFragmentDoc}
${StoneShapeFragmentDoc}
${StoneCrystalFragmentDoc}
${StoneColorFragmentDoc}`;